import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  icon: { alignItems: "center" },
}));

export default useStyle;
